var map = {
	"./bibimbap.png": 9293,
	"./biscuits.png": 8423,
	"./biscuitsCBF.png": 9800,
	"./briochesCardamome.png": 9629,
	"./bucheNoel.jpg": 9198,
	"./cavatelli.png": 3036,
	"./choux.png": 7328,
	"./couscousMerguez.png": 1170,
	"./cowboyCaviar.png": 3080,
	"./curry.png": 7834,
	"./focaccia.png": 7638,
	"./gateauPasCuit.png": 7717,
	"./lemonGreekPotatoes.png": 937,
	"./logo-clementine.png": 7489,
	"./muffinsBleuets.png": 8035,
	"./painSubway.jpg": 1148,
	"./pavlova.png": 2046,
	"./picklesV1.png": 1273,
	"./pizzaRaclette.png": 9273,
	"./potagButternutPoireau.png": 8450,
	"./pouletShishTaouk.png": 7745,
	"./profilTiktok.png": 4563,
	"./sablesChoco.png": 3475,
	"./saladeChoux.png": 9188,
	"./saladeFruits.png": 9598,
	"./saladeQuinoaConcombreCeleri.png": 5444,
	"./shakshuka.png": 9570,
	"./shakshuka2.png": 6730,
	"./soupeTortelliniKalePoulet.png": 4095,
	"./taboule.png": 5919,
	"./touski.png": 7336,
	"./vodkaPasta.png": 7199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;